import type { ValueTypesForAtoms } from "../types";
import { type Atom, useAtomValue } from "jotai";
import type { PickByValue } from "utility-types";

export function useAtomValues<T extends object>(obj: T) {
  return new Proxy<ValueTypesForAtoms<PickByValue<T, Atom<unknown>>>>(
    obj as any,
    {
      get: (target, prop) => {
        const atom = target[prop as keyof typeof target] as Atom<unknown>;
        return useAtomValue(atom);
      },
    }
  );
}
